export const SMART_FIT_TERMS_URL = '/partners/holos/smartfit';

export const SMART_FIT_PRICES = {
  '1 mes': 129,
  '3 meses': 348,
} as const;

export type SmartFitDuration = keyof typeof SMART_FIT_PRICES;

export const getSmartFitPrice = (duration: SmartFitDuration) => SMART_FIT_PRICES[duration];